import React from 'react';
import { useDispatch } from 'react-redux';
import {
  Divider,
  Switch,
  Grid
} from '@material-ui/core';
import { changeAboutUsPageConfigConfig } from 'redux/actions/store_configs';


const AboutUsGeneral = ({values, onChange}) => {
  const dispatch = useDispatch();
  const { general } = values;

  const handleChange = (event) => {
    const {name, checked, type, value} = event.target;
    dispatch(changeAboutUsPageConfigConfig(name, checked, type, value, 'general'));
  };

  return (
    <div>
      <Grid container spacing={3} className="mb-4">
        <Grid item xs={12} sm={2} className="my-2 ml-4">Enable</Grid>
        <Grid item xs={12} sm={9}>
          <Switch
            color="primary"
            name={'store_info/about_us_page/is_about_us_page_enabled'}
            checked={general['store_info/about_us_page/is_about_us_page_enabled'] == 1}
            onChange={(event) => {
              onChange('general[\'store_info/about_us_page/is_about_us_page_enabled\']', event.target.checked ? 1 : 0);
              handleChange(event);
            }}
          />
        </Grid>
      </Grid>
      <Divider className="mb-8" />
    </div>
  );
};

export default AboutUsGeneral;
